import { WIX_NEW_STORES } from '@wix/app-definition-ids';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import { useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { updateCategoriesAltText } from '../../../api/new-infra-updates/update-categories';
import { altTextScreenPageIdAtom } from '../../../atoms/session-atoms';
import { usePanelStateAtom } from '../../../hooks/rules-state';
import { useNavigation } from '../../../hooks/use-navigation';
import { useImageElementsOrder } from '../alt-text/use-image-elements-order';
export const useCategoriesAltTextHandlers = () => {
  const {
    getPagesData
  } = usePanelStateAtom();
  const pageIdToPageData = getPagesData();
  const navigateToPage = useNavigation();
  const {
    getOrderedImageElements
  } = useImageElementsOrder();
  const altTextScreenPageId = useAtomValue(altTextScreenPageIdAtom);
  assertNotOptional(altTextScreenPageId);
  const {
    pageId
  } = altTextScreenPageId;
  const errorHandler = useErrorHandler();
  const httpClient = useHttpClient();
  const innerRoutes = useMemo(() => {
    var _pageIdToPageData$get;
    return (_pageIdToPageData$get = pageIdToPageData.get(pageId)) == null ? void 0 : _pageIdToPageData$get.innerRoutes;
  }, [pageIdToPageData, pageId]);
  const openImageElement = useCallback(nextElement => {
    const entityId = nextElement.entityId;
    navigateToPage(pageId, entityId);
  }, [navigateToPage, pageId]);
  const getEntityName = useCallback(entityId => {
    var _innerRoutes$find;
    return (innerRoutes == null || (_innerRoutes$find = innerRoutes.find(innerRoute => innerRoute.id === entityId)) == null ? void 0 : _innerRoutes$find.name) ?? '';
  }, [innerRoutes]);
  const getElementOrder = useCallback(altImageRuleProps => getOrderedImageElements(altImageRuleProps), [getOrderedImageElements]);
  const enabledDecorativeImages = false;
  const appDefinitionId = WIX_NEW_STORES;
  const setBulkAltText = useCallback(async bulkAltTextData => {
    const response = await updateCategoriesAltText(httpClient, errorHandler, bulkAltTextData);
    if (response.success === false) {
      throw new Error(response.errorMessage);
    }
  }, [errorHandler, httpClient]);
  return useMemo(() => ({
    appDefinitionId,
    enabledDecorativeImages,
    getElementOrder,
    getEntityName,
    openImageElement,
    setBulkAltText
  }), [appDefinitionId, getElementOrder, enabledDecorativeImages, getEntityName, openImageElement, setBulkAltText]);
};
//# sourceMappingURL=use-categories-alt-text-handlers.js.map